module.exports = __webpack_public_path__ + "static/media/popup-bg@3x.fbeb226e.png";